import { CookieStorageService } from '@repo/alt/Services'
import { injectable, inject } from 'inversify'

import { TOKEN_COOKIE_KEY } from '../constants'

@injectable()
export class AuthCookieService {
  public token

  constructor(
    @inject(CookieStorageService)
    private readonly cookieStorageService: CookieStorageService,
  ) {
    this.token = this.cookieStorageService.create<string | null>(
      TOKEN_COOKIE_KEY,
      {
        default: () => null,
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year
      },
    )
  }
}
